import { render, staticRenderFns } from "./TimetableEdit.vue?vue&type=template&id=5723052c"
import script from "../../controllers/timetable/timetable-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/timetable/timetable-edit.js?vue&type=script&lang=js&external"
import style0 from "./TimetableEdit.vue?vue&type=style&index=0&id=5723052c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports